var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "creategroup"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("Map Group Connection")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Destination City"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-home'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('destinationcityid')
    },
    attrs: {
      "options": _vm.cityList,
      "selected-option": _vm.destinationcityObjData,
      "name": "destinationcityid",
      "placeholder": "Select City"
    },
    on: {
      "select": _vm.selectedDestination
    },
    model: {
      value: (_vm.destinationcityid),
      callback: function($$v) {
        _vm.destinationcityid = $$v
      },
      expression: "destinationcityid"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('destinationcityid')),
      expression: "errors.has('destinationcityid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Destination City field is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Group"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('groupType')
    },
    attrs: {
      "options": _vm.groupTypeList,
      "selected-option": _vm.groupTypeObjData,
      "name": "groupType",
      "placeholder": "Select Group"
    },
    on: {
      "select": _vm.selectedGroupType
    },
    model: {
      value: (_vm.groupType),
      callback: function($$v) {
        _vm.groupType = $$v
      },
      expression: "groupType"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('groupType')),
      expression: "errors.has('groupType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('groupType')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Origin Hub"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('origincity')
    },
    attrs: {
      "options": _vm.fetchedHubs,
      "selected-option": _vm.origincityObjData,
      "name": "origincity",
      "placeholder": "Select City"
    },
    on: {
      "select": _vm.selectedOrigin
    },
    model: {
      value: (_vm.origincityid),
      callback: function($$v) {
        _vm.origincityid = $$v
      },
      expression: "origincityid"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('origincity')),
      expression: "errors.has('origincity')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Origin City field is required.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Connection Type"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cubes'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('connectionType')
    },
    attrs: {
      "options": _vm.connectionTypeList,
      "selected-option": _vm.connectionTypeObjData,
      "name": "connectionType",
      "placeholder": "Select Connection Type"
    },
    on: {
      "select": _vm.selectedConnectionType
    },
    model: {
      value: (_vm.connectionType),
      callback: function($$v) {
        _vm.connectionType = $$v
      },
      expression: "connectionType"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('connectionType')),
      expression: "errors.has('connectionType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Connection Type field is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Connection"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-plug'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('connection')
    },
    attrs: {
      "options": _vm.connectionList,
      "selected-option": _vm.connectionObjData,
      "name": "connection",
      "placeholder": "Select Connection"
    },
    on: {
      "select": _vm.selectedConnection
    },
    model: {
      value: (_vm.connectionid),
      callback: function($$v) {
        _vm.connectionid = $$v
      },
      expression: "connectionid"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('connection')),
      expression: "errors.has('connection')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Connection field is required.")]), _vm._v(" "), (_vm.noConnection == true) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("No Connection Found.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#1985ac",
      "font-weight": "bold",
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.actualRoute))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Parent Hub"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('parentHub')
    },
    attrs: {
      "options": _vm.parentHubList,
      "selected-option": _vm.parentHubObjData,
      "name": "parentHub",
      "placeholder": "Select Hub"
    },
    on: {
      "select": _vm.selectedHub
    },
    model: {
      value: (_vm.parentHub),
      callback: function($$v) {
        _vm.parentHub = $$v
      },
      expression: "parentHub"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('parentHub')),
      expression: "errors.has('parentHub')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Parent Hub field is required.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100",
      "margin-top": "15px"
    },
    attrs: {
      "name": "allowBagpattern"
    },
    model: {
      value: (_vm.allowBagpattern),
      callback: function($$v) {
        _vm.allowBagpattern = $$v
      },
      expression: "allowBagpattern"
    }
  }, [_vm._v(" Allow Baggin Pattern")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100",
      "margin-top": "15px"
    },
    attrs: {
      "name": "isActive"
    },
    model: {
      value: (_vm.isActive),
      callback: function($$v) {
        _vm.isActive = $$v
      },
      expression: "isActive"
    }
  }, [_vm._v(" IsActive")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag Type "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.allBagTypes,
      "placeholder": "Select Bag Types"
    },
    on: {
      "select": _vm.selectedBagType
    }
  })], 1)], 1), _vm._v(" "), (_vm.bagTypeSelected == false) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Please Select Atleast 1 Bag Type.")]) : _vm._e(), _vm._v(" "), (_vm.bagTypeFound == false) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Bag Type Not Found.")]) : _vm._e()], 1), _vm._v(" "), (_vm.selectedbagtype) ? _c('div', {
    staticClass: "col-md-9"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Selected Bag Types")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "items"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-y": "scroll"
    }
  }, [_c('ul', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "id": "menu"
    }
  }, [_vm._l((_vm.bagTypenew), function(item, ind) {
    return _c('li', {
      key: item.id
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-close",
      staticStyle: {
        "margin-left": "2px",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.removeBagType(item.id, ind)
        }
      }
    })])
  }), _vm._v(" \n                      ")], 2)])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "groupconnectionfooter form-actions"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.saveGroupMapping
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Clear")])])])])], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("List")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: "fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }, [_vm._v(" Filter")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  })]), _c('br'), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "Tab"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitFlt('Tab')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("City "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Tab.city')
    },
    attrs: {
      "name": "city",
      "options": _vm.cityList,
      "selected-option": _vm.citySearchObjData,
      "data-vv-scope": "Tab",
      "placeholder": "Select City"
    },
    on: {
      "select": _vm.selectedCitySearch
    },
    model: {
      value: (_vm.citySearch),
      callback: function($$v) {
        _vm.citySearch = $$v
      },
      expression: "citySearch"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tab.city')),
      expression: "errors.has('Tab.city')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Tab.city')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Group "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Tab.group')
    },
    attrs: {
      "name": "group",
      "options": _vm.searchGroupList,
      "selected-option": _vm.groupSearchObjData,
      "data-vv-scope": "Tab",
      "placeholder": "Select Group"
    },
    on: {
      "select": _vm.selectedgroupSearch
    },
    model: {
      value: (_vm.groupSearch),
      callback: function($$v) {
        _vm.groupSearch = $$v
      },
      expression: "groupSearch"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tab.group')),
      expression: "errors.has('Tab.group')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Tab.group')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn"
  }, [_c('button', {
    staticClass: "-common-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.getGroupConnectionList
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search Groups Connection")]), _vm._v(" \n                  ")])])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "200px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingflt
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingflt = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Group Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Group Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Connection ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent Hub ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0 && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("Select City From Search Filter")])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("Group Template Not Found For The Selected City")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.grpConnMapList), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.groupno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.groupname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "badge badge-warning",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getParentHubRowData(data)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(data.parenthubname) + "\n                ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.isactive == true) ? _c('span', {
      staticClass: "badge badge-success",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getStatusRowData(data)
        }
      }
    }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (data.isactive == false) ? _c('span', {
      staticClass: "badge badge-danger",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getStatusRowData(data)
        }
      }
    }, [_vm._v("Inactive")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-university fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#6bd5e1"
      },
      attrs: {
        "title": "Allocate Hubs"
      },
      on: {
        "click": function($event) {
          return _vm.openHubMapModal(data)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Mapped Hubs"
      },
      on: {
        "click": function($event) {
          return _vm.getHubMappedListData(data)
        }
      }
    })])])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > 2),
      expression: "totalRows>2"
    }],
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.updateparentHubmodal = false
      }
    },
    model: {
      value: (_vm.updateparentHubmodal),
      callback: function($$v) {
        _vm.updateparentHubmodal = $$v
      },
      expression: "updateparentHubmodal"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Allocate Hubs")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeUpdateParentHub
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Hub List")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    attrs: {
      "options": _vm.searchparentHubList,
      "selected-option": _vm.searchparentHubListObjData,
      "name": "searchparentHub",
      "id": "searchparentHub",
      "placeholder": "Select Hub"
    },
    on: {
      "select": _vm.selectedsearchparentHub
    },
    model: {
      value: (_vm.searchparentHub),
      callback: function($$v) {
        _vm.searchparentHub = $$v
      },
      expression: "searchparentHub"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "rolefooter form-actions"
  }, [_c('b-button', {
    staticClass: "--common-success",
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": _vm.updateparentHub
    }
  }, [_vm._v("Update Hub")]), _vm._v(" "), _c('b-button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.closeUpdateParentHub
    }
  }, [_vm._v("Cancel")])], 1)])])], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.groupConnectionStatusModal = false
      }
    },
    model: {
      value: (_vm.groupConnectionStatusModal),
      callback: function($$v) {
        _vm.groupConnectionStatusModal = $$v
      },
      expression: "groupConnectionStatusModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusGroupModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(" Do you want to " + _vm._s(_vm.changestatus) + " this Group Connection?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.changeGroupConnectionStatus, function($event) {
        _vm.groupStatusModal = false
      }]
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusGroupModal
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.allocateHubmodal = false
      }
    },
    model: {
      value: (_vm.allocateHubmodal),
      callback: function($$v) {
        _vm.allocateHubmodal = $$v
      },
      expression: "allocateHubmodal"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Allocate Hubs")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeAllocateHubModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Hub List")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    attrs: {
      "options": _vm.fetchedHubs,
      "selected-option": _vm.maphubObjData,
      "name": "mapHubId",
      "id": "mapHubId",
      "placeholder": "Select Hub"
    },
    on: {
      "select": _vm.selectedHubName
    },
    model: {
      value: (_vm.mapHubId),
      callback: function($$v) {
        _vm.mapHubId = $$v
      },
      expression: "mapHubId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "rolefooter form-actions"
  }, [_c('b-button', {
    staticClass: "glass",
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": _vm.saveMapHubWithGroupConnection
    }
  }, [_vm._v("Map Hub")]), _vm._v(" "), _c('b-button', {
    staticClass: "glasssec",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.closeAllocateHubModal
    }
  }, [_vm._v("Cancel")])], 1)])])], 1)])]), _vm._v(" "), (_vm.showHubsModal == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Hubs List"
    },
    model: {
      value: (_vm.showHubsModal),
      callback: function($$v) {
        _vm.showHubsModal = $$v
      },
      expression: "showHubsModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Mapped Hubs")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeHubsModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status ")])])]), _vm._v(" "), _c('tbody', [(_vm.mappedHubCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No Hub Mapped")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.mappedHUbsList), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.isactive == true) ? _c('span', {
      staticClass: "badge badge-success",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getStatusHublistData(data)
        }
      }
    }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (data.isactive == false) ? _c('span', {
      staticClass: "badge badge-danger",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getStatusHublistData(data)
        }
      }
    }, [_vm._v("Inactive")]) : _vm._e()])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeHubsModal
    }
  }, [_vm._v("Close")])])])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.hubStatusModal = false
      }
    },
    model: {
      value: (_vm.hubStatusModal),
      callback: function($$v) {
        _vm.hubStatusModal = $$v
      },
      expression: "hubStatusModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusHubModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(" Do you want to " + _vm._s(_vm.changestatusHub) + " this Hub From Group Id?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.changeMappedHubStatus, function($event) {
        _vm.hubStatusModal = false
      }]
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusHubModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-275d3fd0","hasScoped":true}!./src/views/components/group/groupmapping/groupmapping_component.html
// module id = 880
// module chunks = 2